const DEFAULT_REDIRECT = '/';
const ANIMA_HOSTNAME = 'animaapp.com';

const getWindowLocation = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.location;
};

const getCurrentOrigin = ({ currentOrigin, location } = {}) => {
  if (currentOrigin) {
    return currentOrigin;
  }
  return location?.origin || getWindowLocation()?.origin;
};

export const isAllowedAnimaHostname = (hostname) => {
  const normalizedHostname = hostname?.toLowerCase();
  return normalizedHostname === ANIMA_HOSTNAME || !!normalizedHostname?.endsWith(`.${ANIMA_HOSTNAME}`);
};

export const sanitizeRedirect = (redirect, options = {}) => {
  const { fallback = DEFAULT_REDIRECT } = options;

  if (typeof redirect !== 'string') {
    return fallback;
  }

  const value = redirect.trim();
  if (!value || value.includes('\\')) {
    return fallback;
  }

  if (value.startsWith('/')) {
    return value.startsWith('//') ? fallback : value;
  }

  let url;
  try {
    url = new URL(value);
  } catch (err) {
    return fallback;
  }

  const currentOrigin = getCurrentOrigin(options);
  if (currentOrigin && url.origin === currentOrigin) {
    return `${url.pathname}${url.search}${url.hash}`;
  }

  if (url.protocol === 'https:' && isAllowedAnimaHostname(url.hostname)) {
    return url.href;
  }

  return fallback;
};

export const isExternalRedirect = (redirect) => {
  return typeof redirect === 'string' && redirect.startsWith('https://');
};

export const navigateToExternalRedirect = (redirect, location = getWindowLocation()) => {
  if (!location) {
    return;
  }

  location.href = redirect;
};
